import LandingPage from '../landing/LandingPage';
import SeoHead from '../seo/SeoHead';

function Journey() {
  return (
    <>
      <SeoHead
        title="Clarana — AI Personal Growth & Goal Companion"
        description="Your AI companion for personal growth, goal setting, journaling, and emotional support."
        path="/"
      />
      <LandingPage />
    </>
  );
}

export default Journey;